module.exports = __webpack_public_path__ + "img/wlQR.93b97018.png";